const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => {
    let avatar = state.user.avatar;
    if (avatar == null) {
      return 'https://cxyptest.gdyibo.com.cn/file/1f/72/07/41/1f720741ac52c100c5e93ad10ed6f307.png'
    }
    return avatar;
  },
  userId: state => state.user.id,
  accountType: state => state.user.accountType,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  permission_routes: state => state.permission.routes,
  errorLogs: state => state.errorLog.logs,
  permissions: state => state.user.permissions,// 用户拥有的权限

  config: state => state.config.config,
  isNeedChangePass:state => state.user.isNeedChangePass,
  isValidateCode:state => state.user.isValidateCode,
  mobile: state => state.user.mobile


}
export default getters
